import React, { Component } from "react";
import { connect } from "react-redux";

import ConditionComponent from "./ConditionComponent";

import { addCondition } from "Actions";

class Condition extends Component {
  render() {
    return <ConditionComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = (state, ownProps) => ({
  categories: state.filters[ownProps.type].categories,
  types: state.filters[ownProps.type].types,
  themes: state.filters[ownProps.type].themes,
  lng: state.params.lng,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  addCondition: (order, condition) => dispatch(addCondition(order, condition))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Condition);



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Filter/Condition/index.js